<template>
  <div id="app">
    <commonhead :active_menu="-1" :callback="authcallback" />
    <div class="teacher_list">
      <div class="content">
        <div class="item pr" v-if="orderData&&orderData.course&&orderData.course.length > 0">
          <div class="left">
            <span class="pic">
              <img :src="orderData.course[0].teacher.avatar" class="pic_full" />
            </span>
            <div class="info">
              <p>
                <span class="head">订单号</span>
                <span class="value">{{orderData.order.order_id}}</span>
              </p>
              <p>
                <span class="head">下单时间</span>
                <span class="value">{{orderData.order.created_at}}</span>
              </p>
              <p>
                <span class="head">教师姓名</span>
                <span class="value">{{orderData.course[0].teacher.real_name}}</span>
              </p>
              <p>
                <span class="head">联系方式</span>
                <span class="value">QQ: {{orderData.course[0].teacher.qq}}</span>
              </p>
            </div>
          </div>
          <div class="right_area pr">
            <p class="title">课程列表</p>
            <div class="course_info" v-for="(item,index) in orderData.course" :key="index">
              <span class="index">{{index+1}}</span>
              上课时间：{{getLocalTime(item.start)}}
            </div>
          </div>
        </div>
        <div v-if="!is_paid">
        <p class="settle_title">
          <span class="title_text">选择支付方式付款</span>
          应付金额
          <span class="money_num">{{now_price}}</span>
          <span class="red">元</span>或
          <span class="money_num">{{now_price}}</span>
          <span class="red">学贝</span>
          <i class="el-icon-bell"></i>(购买学贝套餐更加优惠
          <span class="red hand_point" @click="$router.push('./user-center-buy')">去购买学贝</span>)
        </p>
        <div class="pay_way">
          <div class="pay_way_item hand_point" @click="change_way(2)">
            <span class="active_icon" v-if="pay_type == 2">
              <img src="../../assets/image/user_center/btn_hover (2).png" alt class="pic_full" />
            </span>
            <span class="active_icon" v-if="pay_type != 2">
              <img src="../../assets/image/user_center/pay_no_select.png" alt class="pic_full" />
            </span>
            <span class="pay_way_text">学贝</span>
            <span class="fr">
              <span class="total_text">应付金额：</span>
              <span class="total_money">{{now_price}}</span>
              <span class="yuan">学贝</span>
            </span>
          </div>
          <div class="divider"></div>
          <div class="pay_way_item hand_point" @click="change_way(0)">
            <span class="active_icon" v-if="pay_type == 0">
              <img src="../../assets/image/user_center/btn_hover (2).png" alt class="pic_full" />
            </span>
            <span class="active_icon" v-if="pay_type != 0">
              <img src="../../assets/image/user_center/pay_no_select.png" alt class="pic_full" />
            </span>
            <span class="pay_way_icon">
              <img src="../../assets/image/user_center/ali_pay.png" alt class="pic_full" />
            </span>
            <span class="pay_way_text">支付宝</span>
            <span class="fr">
              <span class="total_text">应付金额：</span>
              <span class="total_money">{{now_price}}</span>
              <span class="yuan">元</span>
            </span>
          </div>
          <div class="divider"></div>
          <div class="pay_way_item hand_point" @click="change_way(1)">
            <span class="active_icon" v-if="pay_type == 1">
              <img src="../../assets/image/user_center/btn_hover (2).png" alt class="pic_full" />
            </span>
            <span class="active_icon" v-if="pay_type != 1">
              <img src="../../assets/image/user_center/pay_no_select.png" alt class="pic_full" />
            </span>
            <span class="pay_way_icon">
              <img src="../../assets/image/user_center/wehcat_pay.png" alt class="pic_full" />
            </span>
            <span class="pay_way_text">微信</span>
            <span class="fr">
              <span class="total_text">应付金额：</span>
              <span class="total_money">{{now_price}}</span>
              <span class="yuan">元</span>
            </span>
          </div>
          <button class="pay_btn hand_point" v-if="!is_paying&&pay_out">超时未支付已取消</button>
          <button class="pay_btn hand_point" @click="pay" v-if="!is_paying&&!pay_out">去支付</button>
          <button class="pay_btn" disabled v-if="is_paying&&!pay_out">
            <i class="el-icon-loading" style="margin-right:10px"></i>去支付
          </button>
          <div class="clear"></div>
        </div>
        </div>
        <div v-else>
          <button class="pay_btn hand_point" @click="back">返回</button>
          <div class="clear"></div>
        </div>
      </div>
    </div>
    <!--公共底部-->
    <commonfoot />
    <!--公共底部-->
  </div>
</template>

<script>
import { common } from "../../../common.js";
import commonhead from "../common/common_head.vue";
import commonfoot from "../common/common_foot.vue";
export default {
  name: "app",
  components: {
    commonhead,
    commonfoot
  },
  data: function() {
    return {
      orderData: "",
      pay_type: 2,
      now_price: "",
      is_paying: false,
      is_paid:false,
      pay_out: false
    };
  },
  mounted: function() {
    this.is_paid = this.$route.query.is_paid == 1 ? true:false;
    if (this.$route.query.order_id) {
      this.getList(this.$route.query.order_id);
    }
  },
  methods: {
     back() {
      this.$router.go(-1);
    },
    getList(order_id) {
      let self = this;
      common.requestFun(
        self,
        "get",
        "/payment/order/info",
        {
          order_id: order_id
        },
        res => {
          if (res.data.code == 200) {
            self.orderData = res.data.data;
            self.now_price = res.data.data.order.total;
            const time = new Date(self.orderData.order.created_at.replace(/-/g,'/')).getTime();
            if(new Date().getTime()-time>5*60*1000){
              self.pay_out = true;
            }
          }
        }
      );
    },
    getLocalTime(nS) {
      return new Date(parseInt(nS) * 1000)
        .toLocaleString()
        .replace(/:\d{1,2}$/, " ");
    },
    change_way(way) {
      this.pay_type = way;
    },
    pay() {
      //type 0支付宝,1微信 2学贝
      let type = this.pay_type;
      let order_id = this.$route.query.order_id;
      let price = this.now_price;
      this.is_paying = true;
      let self = this;
      if (type == 0) {
        let redirectURL = encodeURIComponent("/#/user-center-order");
        if (order_id) {
          this.is_paying = false;
          window.location.href = `https://gemsbaby.com/payment/alipay?order_id=${order_id}&redirectURL=${redirectURL}`;
        }
      }
      if (type == 1) {
        if (order_id) {
          this.is_paying = false;
          self.$router.push(`./wxpay?order_id=${order_id}&price=${price}`);
        }
      }
      if (type == 2) {
        if (order_id) {
          common.requestFun(
            self,
            "get",
            "/payment/coin",
            {
              order_id: order_id
            },
            res => {
              if (res.data.code == 200) {
                self.$message({
                  message: "支付成功",
                  type: "success",
                  center: true
                });
                self.is_paying = false;
                self.$router.push(`./user/course`);
              } else {
                self.is_paying = false;
                if (res.data.msg) {
                  self.$message({
                    message: res.data.msg,
                    type: "error",
                    center: true
                  });
                }
              }
            }
          );
        }
      }
    },
    authcallback(isLogin){
      if(!isLogin){
          this.$message({
              message: "请登录",
              type: "error",
              center: true
          });
          this.$router.push("./");
      }
    },
  }
};
</script>
<style scoped src="./order_detail.css"></style>
